import { transportResources } from '@/api/index'

export function getMapUrl () {
  return transportResources.request({
    method: 'post',
    url: '/GetMapUrl'
  })
}

export function getVehicleExpires () {
  return transportResources.request({
    method: 'get',
    url: '/GetVehicleExpires'
  })
}

export function myGPSinfo (data) {
  return transportResources.request({
    method: 'post',
    url: '/MyGPSinfo',
    data,
    iSFromData: true
  })
}
